import { Box, Flex } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import { useOnload } from "@utils/useOnLoad";
import CloneChildren from "@components/children";
import { useContext } from "react";
import { Context } from "@components/useContext/context";

const getSelectedAddons = (selectedAddons, addon, index) => {
  const sa_size = selectedAddons.length;

  if (index === sa_size - 2) {
    return `${addon.name} and `;
  } else if (index === sa_size - 1) {
    return `${addon.name} `;
  } else {
    return `${addon.name}, `;
  }
};

const MultiYearPlan = ({ children, ...props }) => {
  const {
    displayText,
    selectedPlan,
    selectedAddons,
    styles,
    actions,
    is_visible,
    childrenStyles,
    bannerStyles,
    textStyles,
    tenure,
    threeYearText
  } = props;
  const { on_load } = actions || {};
  const { isDesktop } = useContext(Context);

  const fontSize = isDesktop ? "16px" : "14px";
  const marginBottom = props.marginBottom;

  useOnload({ on_load });
  return is_visible ? (
    <Box>
      <Flex style={bannerStyles}>
        {tenure === 3 ? (
          <Text
            styles={textStyles}
            style={{
              fontSize,
              fontWeight: 500,
              lineHeight: "20px",
              display: "inline",
              marginBottom
            }}
          >
            {threeYearText}
          </Text>
        ) : (
          displayText && (
            <Text
              styles={textStyles}
              style={{
                fontSize,
                fontWeight: 500,
                lineHeight: "20px",
                display: "inline",
                marginBottom
              }}
            >
              {displayText} -{" "}
              <span style={{ fontWeight: 400, color: "#36354C" }}>
                {selectedPlan} {selectedAddons.length > 0 ? " with " : ""}
                {selectedAddons.map((addon, index) => {
                  return getSelectedAddons(selectedAddons, addon, index);
                })}
              </span>
            </Text>
          )
        )}
      </Flex>

      <CloneChildren
        children={children}
        styles={childrenStyles}
      ></CloneChildren>
    </Box>
  ) : null;
};

export default MultiYearPlan;
